import React from "react";
import { connect } from "react-redux";
import { Breadcrumb } from "antd";
import { clearHistory } from "store/slice/url-history-slice";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import "./BreadCrumbHistory.scss";
import RouteFields from "Routes/RouteFields";
function convertToReadableFormat(str) {
  return (
    str
      .split("-") // Split the string by hyphen
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(" ") || ""
  ); // Join the words with a space
}
const BreadCrumbHistory = ({ history, clearHistory }) => {
  return (
    <>
      {history.length > 1 && (
        <Breadcrumb className="breadCrumbHistory">
          {history.map((url, index) => {
            const endpoint = url.split("/").filter(Boolean).pop() || "";
            // const formatedEndpoint = convertToReadableFormat(endpoint);
            const formatedEndpoint = RouteFields[endpoint];
            return (
              <Breadcrumb.Item key={index} className="breadCrumbHistoryItems">
                {index == history.length - 1 ? (
                  <p>{formatedEndpoint}</p>
                ) : (
                  <Link to={url}>{formatedEndpoint}</Link>
                )}
              </Breadcrumb.Item>
            );
          })}
        </Breadcrumb>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  history: state.urlHistoryReducer.history,
});

const mapDispatchToProps = {
  clearHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(BreadCrumbHistory);
